<template>
    <div v-if="visible" class="google-search modal html">
        <span class="close-button" @click="hide"><i class="fas fa-times"></i></span>

        <div class="container">
            <div class="html-body">
                <div class="search-header">
                    <div class="inner">
                        <a href="/" class="logo"></a>
                        <div class="input-group">
                            <input
                                    type="text"
                                    :placeholder="placeholder"
                                    class="input-group-field"
                                    @input="debounceInput"
                                    v-model="query"
                                    v-bind:autofocus="visible"
                            >
                            <span class="input-group-button">
                                <span class="small button non-click">
                                    <i class="fas fa-search" v-show="!fetching"></i>
                                    <i class="fas fa-spinner fa-spin" v-show="fetching"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="search-results">
                    <div v-if="spelling" class="spelling">Did you mean <a href="javascript:void(0);"
                                                                          v-html="spellingHtml"
                                                                          @click="correctSpelling"></a>?
                    </div>

                    <div v-if="totalResults === 0" class="no-results">
                        <p>No results containing all your search terms were found.</p>
                        <p>Your search - {{ query }} - did not match any documents.</p>
                        <p>Suggestions:</p>
                        <ul>
                            <li>Make sure that all words are spelled correctly.</li>
                            <li>Try different keywords.</li>
                            <li>Try more general keywords.</li>
                        </ul>
                    </div>

                    <div v-for="item in items" class="result">
                        <div class="title"><a :href="item.link" v-html="item.htmlTitle"></a></div>
                        <div class="url"><a :href="item.link" v-html="item.htmlFormattedUrl"></a></div>
                        <div v-if="item.pagemap && item.pagemap.cse_thumbnail" class="image">
                            <img :src="item.pagemap.cse_thumbnail[0].src" :width="item.pagemap.cse_thumbnail[0].width"
                                 :height="item.pagemap.cse_thumbnail[0].height" :alt="items.title"/>
                        </div>
                        <div class="snippet" v-html="item.htmlSnippet"></div>
                    </div>

                    <div v-if="previousIndex || nextIndex" class="pagination">
                        <a v-if="previousIndex" @click="previousPage" href="javascript:void(0);">&lt;&lt; Previous
                            page</a>
                        <span v-if="previousIndex && nextIndex"> | </span>
                        <a v-if="nextIndex" @click="nextPage" href="javascript:void(0);">Next page &gt;&gt;</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            placeholder: {
                type: String,
                required: false,
                default: 'Search for...',
            },
        },
        data() {
            return {
                fetching: false,
                query: '',
                previousIndex: false,
                currentIndex: 1,
                nextIndex: false,
                time: 0,
                totalResults: false,
                spelling: false,
                spellingHtml: false,
                items: [],
                visible: false,
            };
        },
        created() {
            const key = document.head.querySelector('meta[name="google-api-key"]').content;
            const console_id = document.head.querySelector('meta[name="google-search-console-id"]').content;
            this.route = 'https://www.googleapis.com/customsearch/v1?key=' + key + '&cx=' + console_id;
            this.debounceInput = window._.debounce(this.fetch, 400);
            window.EventHandler.listen('open-search', this.show);
        },
        methods: {
            show() {
                this.visible = true;
            },
            hide() {
                this.visible = false;
            },
            previousPage() {
                if (this.previousIndex) {
                    this.currentIndex = this.previousIndex;
                    this.fetch();
                } else {
                    this.failure('There are no previous pages to load');
                }
            },
            nextPage() {
                if (this.nextIndex) {
                    this.currentIndex = this.nextIndex;
                    this.fetch();
                } else {
                    this.failure('There are no more pages to load');
                }
            },
            correctSpelling() {
                this.query = this.spelling;
                this.fetch();
            },
            fetch() {
                let route = [
                    this.route,
                    'start=' + this.currentIndex,
                    'q=' + this.query,
                ];
                this.call(route.join('&'));
            },
            call(route) {
                this.fetching = true;

                window.axios.defaults.headers.common = {};
                window.axios.get(route, { headers: {} }).then(this.success).catch(this.failure);
            },
            success(response) {
                this.fetching = false;
                this.previousIndex = (response.data.queries.previousPage) ?
                    parseInt(response.data.queries.previousPage[0].startIndex) :
                    false;
                this.nextIndex = (response.data.queries.nextPage) ?
                    parseInt(response.data.queries.nextPage[0].startIndex) :
                    false;
                this.time = response.data.searchInformation.searchTime;
                this.totalResults = parseInt(response.data.searchInformation.totalResults);
                this.spelling = (response.data.spelling) ? response.data.spelling.correctedQuery : false;
                this.spellingHtml = (response.data.spelling) ? response.data.spelling.htmlCorrectedQuery : false;
                this.items = (response.data.items) ? response.data.items : [];
                document.querySelector('.google-search.modal .html-body').scrollTop = 0;
            },
            failure(error) {
                this.fetching = false;
                window.EventHandler.fire('top-warning', {
                    id: 1,
                    message: error,
                });
            },
        },
    };
</script>
